import { StoreState } from "../../context/AppContext";

/**
 * Revisar permiso del modulo
 * @param { StoreState } state 
 * @param { 'read' | 'create' | 'update' | 'delete' } action - permiso a consultar
 * @returns 
 */
export function checkPermission(state: StoreState, action: 'read' | 'create' | 'update' | 'delete' ): boolean{
    if(state.menu.loaded && state.menu.modulos && state.module){
        const mod: any = state.module;
            return mod[action];
    }
    return false;
}